import React, { Component } from "react";
import IconFacebook from "ReactComponents/Shared/Icons/icon-facebook";
import IconTwitter from "ReactComponents/Shared/Icons/icon-twitter";
import IconMailStroke from "ReactComponents/Shared/Icons/icon-mail-stroke";

class SocialShare extends Component {
    constructor(props) {
        super(props);

        this.state = {
            facebookUrl: "",
            twitterUrl: "",
            mailUrl: ""
        };
    }

    popupWindow(e, intWidth, intHeight, blnResize) {
        if (window) {
            e.preventDefault();

            const link = e.currentTarget;
            // Set values for window
            const intWidth = intWidth || "500";
            const intHeight = intHeight || "400";
            const strResize = blnResize ? "yes" : "no";

            // Set title and open popup with focus on it
            const strTitle = link.getAttribute("title") || "Social Share";
            const strParam = "width=" + intWidth + ",height=" + intHeight + ",resizable=" + strResize;
            window.open(link.getAttribute("href"), strTitle, strParam);
        }
    }

    componentDidMount() {
        const pageTitle = document.title;
        const url = window.location.href;
        const facebookShareUrl = `http://www.facebook.com/share.php?u=${url}&title=${pageTitle}`;
        const twitterShareUrl = `http://twitter.com/intent/tweet?text=${pageTitle}&url=${url}`;
        const emailUrl = `mailto:${this.props.MailTo}?subject=Mail send via GU&body=Mail body content`;

        this.setState({
            facebookUrl: facebookShareUrl,
            twitterUrl: twitterShareUrl,
            mailUrl: emailUrl
        });
    }

    render() {
        return (
            <div>
                <div className="content-row">
                    <div className="social-share">
                        <span className="social-share__text">{this.props.TitleText}</span>
                        <a
                            onClick={this.popupWindow.bind(this)}
                            target="_blank"
                            href={this.state.facebookUrl}
                            title="Del via Facebook"
                            aria-label="Del via Facebook"
                            className="social-share__iconwrap social-share__icon-facebook"
                        >
                            <IconFacebook />
                        </a>
                        <a
                            onClick={this.popupWindow.bind(this)}
                            target="_blank"
                            href={this.state.twitterUrl}
                            title="Del via Twitter"
                            aria-label="Del via Twitter"
                            className="social-share__iconwrap social-share__icon-twitter"
                        >
                            <IconTwitter />
                        </a>
                        <a
                            href={this.state.mailUrl}
                            title="Del via Mail"
                            aria-label="Del via Mail"
                            className="social-share__iconwrap social-share__icon-mail"
                        >
                            {" "}
                            <IconMailStroke />
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}
export default SocialShare;
